// @flow
import styled from 'styled-components';

export const Base = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/schedule/styles.js